export enum WoocommercePackagingMode {
    AUTO = "Auto",
    ONE_PACKAGE = "OnePackage",
}

export enum WoocommerceSyncMode {
    AUTOMATIC = "Auto",
    MANUAL = "Manual",
}